

export const veoExamples = {
    title: 'AI 影片創作範例 — 關鍵幀控制與多圖參考',
    sub:
      '探索先進模型的影片生成能力：關鍵幀控制、多圖參考、原生音訊。從圖片到電影級影片，體驗 AI 影片創作的無限可能。',
    originalImage: '原始圖片',
    generatedVideo: 'AI 生成影片',
    pill: 'AI Video'
  };
